
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/city/[...slug]",
      function () {
        return require("private-next-pages/[country]/city/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country]/city/[...slug]"])
      });
    }
  